import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _Form from "antd/es/form";
import React, { Component } from 'react';
import ShortText from '../../common/Question/ShortText';
import FillinShort from '../../common/Question/FillinShort';
import InputSingleLine from './InputSingleLine';
var FormItem = _Form.Item;
var ShortTextPC = /*#__PURE__*/function (_Component) {
  _inherits(ShortTextPC, _Component);
  function ShortTextPC() {
    _classCallCheck(this, ShortTextPC);
    return _possibleConstructorReturn(this, _getPrototypeOf(ShortTextPC).apply(this, arguments));
  }
  _createClass(ShortTextPC, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        label = _this$props.label,
        question = _this$props.question;
      var restrictions = (window.showMultiLang ? question === null || question === void 0 ? void 0 : question["".concat(window.language, "Restrictions")] : question.restrictions) || {};
      var maxWords = restrictions.maxWords,
        openWordsRestriction = restrictions.openWordsRestriction;
      var content = function content(_ref) {
        var error = _ref.error,
          formAnswer = _ref.formAnswer,
          _onChange = _ref.onChange,
          placeholder = _ref.placeholder;
        return React.createElement(FormItem, {
          label: label,
          validateStatus: error ? 'error' : null,
          hasFeedback: true,
          help: error,
          required: question.required
        }, React.createElement(InputSingleLine, {
          value: formAnswer.text || '',
          onChange: function onChange(e) {
            return _onChange(e.target.value);
          },
          placeholder: placeholder,
          maxLength: openWordsRestriction ? maxWords : -1,
          maxwords: openWordsRestriction ? maxWords : -1,
          style: {
            marginTop: 0
          }
        }));
      };
      return /fillin/.test(question.type) ? React.createElement(FillinShort, this.props, content) : React.createElement(ShortText, this.props, content);
    }
  }]);
  return ShortTextPC;
}(Component);
export { ShortTextPC as default };